import { guardArray } from "../array";
import type { Plan } from "../types";

/**
 * This function processes the plans to ensure that the crews and ticket assignments are properly formatted.
 * @param plans
 * @returns
 */
export function processPlans(hostOrgId: string, plans: Plan[]) {
	return plans.map((plan) => {
		plan._crews = guardArray(plan._crews);
		plan._crews = sortByRanking(plan._crews);
		plan._crews = sortByOrganizationName(plan._crews);
		plan._crews = sortByHostEquality(hostOrgId, plan._crews);
		plan._crews = plan._crews.map((crew) => {
			crew._ticketAssignments = sortByRanking(crew._ticketAssignments);
			crew._userAssignments = sortByRanking(crew._userAssignments);
			return crew;
		});
		return plan;
	});
}

/**
 * This function sorts an array of items by their ranking property.
 * @param items
 * @returns
 */
function sortByRanking<
	T extends
		| Plan["_crews"]
		| Plan["_crews"][number]["_userAssignments"]
		| Plan["_crews"][number]["_ticketAssignments"],
>(items: T): T {
	items.sort((a, b) => {
		if (a.ranking === b.ranking) return 0;
		if (a.ranking === null) return 1;
		if (b.ranking === null) return -1;
		return a.ranking - b.ranking;
	});
	return items;
}

/**
 * This function sorts an array of items by their organization name property.
 * @param items
 * @returns
 */
function sortByOrganizationName(items: Plan["_crews"]) {
	items.sort((a, b) => {
		return a._organization.name.localeCompare(b._organization.name);
	});
	return items;
}

/**
 * This function sorts an array of items by their host organization ID.
 * @param hostOrgId
 * @param items
 * @returns
 */
function sortByHostEquality(hostOrgId: string, items: Plan["_crews"]) {
	const ownCrews = items.filter((crew) => crew._organization.id === hostOrgId);
	const partnerCrews = items.filter((crew) => crew._organization.id !== hostOrgId);
	return ownCrews.concat(partnerCrews);
}
